import React from 'react';
import './Loader.css';

export const Loader = () => {
    return (
        <div className="lds-dual-ring"></div>
    )
}
